import LabPage from "../components/layout/LabPage";
import { ClipboardList, CheckSquare, NotebookPen, FileText, Calculator, Wand2, Map, ListChecks } from "lucide-react";

export default function WorkbookLab() {
  return (
    <LabPage
      testId="workbook-lab-page"
      kicker="WorkbookLab"
      title="Printable, fillable, interactive workbooks"
      description="From workshop to challenge to course companion — generate fully structured workbooks with cover, exercises, reflections, and answer sheets."
      heroImage="https://images.unsplash.com/photo-1568667256549-094345857637?w=900&q=80"
      heroTone="lime"
      actions={[{ label: "Start Workbook", icon: Wand2, to: "/create" }]}
      quickActions={[
        { label: "Cover Page", icon: FileText },
        { label: "Reflection Block", icon: NotebookPen },
        { label: "Worksheet Block", icon: ListChecks },
        { label: "Roadmap Block", icon: Map },
      ]}
      features={[
        { icon: ClipboardList, title: "10 Workbook Types", description: "Workshop, webinar, course, coaching, challenge, lead magnet, onboarding…" },
        { icon: CheckSquare, title: "Smart Form Blocks", description: "Lines, checkboxes, multiple choice, signatures — print or fillable." },
        { icon: Calculator, title: "Calculator Pages", description: "ROI, pricing, capacity — AI builds calculator inputs from prompt." },
        { icon: Map, title: "Roadmap & Timeline", description: "Auto-generate week-by-week or milestone-based plans." },
        { icon: NotebookPen, title: "Answer Sheet", description: "Printable answer key for facilitators." },
        { icon: FileText, title: "Footer System", description: "Workbook number, event name, page numbers across all pages." },
      ]}
      styles={[
        { tag: "Layout", title: "Workshop Companion", description: "Cover · Intro · 7 sections · Reflections · Commitment." },
        { tag: "Layout", title: "5-Day Challenge", description: "Daily layout with calls, action items, and evening recap." },
        { tag: "Layout", title: "Course Companion", description: "Module-aligned worksheets and self-checks." },
        { tag: "Layout", title: "Coaching Pack", description: "Client onboarding · Discovery · Custom plan pages." },
      ]}
      sampleAssets={[
        { title: "5-Day Cashflow Challenge", thumb: "https://images.unsplash.com/photo-1611162616475-46b635cb6868?w=500&q=80", meta: "32 pages" },
        { title: "Operator's Companion", thumb: "https://images.unsplash.com/photo-1456406644174-8ddd4cd52a06?w=500&q=80", meta: "18 pages" },
        { title: "Webinar Worksheet", thumb: "https://images.unsplash.com/photo-1517842645767-c639042777db?w=500&q=80", meta: "8 pages" },
        { title: "VIP Onboarding Pack", thumb: "https://images.unsplash.com/photo-1583321500900-82807e458f3c?w=500&q=80", meta: "24 pages" },
      ]}
    />
  );
}
